var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tw-flex tw-flex-col sm:tw-items-center tw-justify-center tw-h-screen tw-bg-gray-100"})])
}]

export { render, staticRenderFns }